/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/unbound-method */
if (Element && !Element.prototype.matches) {
	const proto = (Element as any).prototype;
	proto.matches =
		proto.matchesSelector ||
		proto.mozMatchesSelector ||
		proto.msMatchesSelector ||
		proto.oMatchesSelector ||
		proto.webkitMatchesSelector;
}

// Source: https://github.com/naminho/svg-classlist-polyfill/blob/master/polyfill.js
if (!("classList" in SVGElement.prototype)) {
	Object.defineProperty(SVGElement.prototype, "classList", {
		get: function get() {
			const _this = this;

			return {
				contains: function contains(className) {
					return _this.className.baseVal.split(" ").indexOf(className) !== -1;
				},
				add: function add(className) {
					return _this.setAttribute("class", _this.getAttribute("class") + " " + className);
				},
				remove: function remove(className) {
					const removedClass = _this
						.getAttribute("class")
						.replace(new RegExp("(\\s|^)".concat(className, "(\\s|$)"), "g"), "$2");

					if (_this.classList.contains(className)) {
						_this.setAttribute("class", removedClass);
					}
				},
				toggle: function toggle(className) {
					if (this.contains(className)) {
						this.remove(className);
					} else {
						this.add(className);
					}
				},
			};
		},
		configurable: true,
	});
}

// Source: https://github.com/tc39/proposal-object-values-entries/blob/master/polyfill.js
if (!Object.entries) {
	const reduce = Function.bind.call(Function.call, Array.prototype.reduce);
	const isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
	const concat = Function.bind.call(Function.call, Array.prototype.concat);

	Object.entries = function entries(O) {
		return reduce(
			Object.keys(O),
			(e, k) => concat(e, typeof k === "string" && isEnumerable(O, k) ? [[k, O[k]]] : []),
			[]
		);
	};
}

// Source: https://gist.github.com/rockinghelvetica/00b9f7b5c97a16d3de75ba99192ff05c
if (!Event.prototype.composedPath) {
	Event.prototype.composedPath = function() {
		if (this.path) {
			return this.path;
		}
		let target = this.target;

		this.path = [];
		while (target.parentNode !== null) {
			this.path.push(target);
			target = target.parentNode;
		}
		this.path.push(document, window);
		return this.path;
	};
}
